/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {gettHeaderByType, settHeaderByType} from '@/api/common'
import {
    getCustomerConversionResaleOrderContractUrlById,
    getCustomerConversionResaleOrderBackMoneyUrlById,
    getCustomerConversionResaleOrderList,
    setCustomerConversionResaleOrderBackMoneyUrlById,
    setCustomerConversionResaleOrderById,
    getCustomerConversionResaleOrderById
} from '@/api/customer'

import {menuBtn} from '@/utils/menu_level2_button'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class ResaleOrder extends Vue {
    [x: string]: any

    socket: any = null
    tableHeadPopoverShow = false

    tableData = []
    tableHeader = []
    checkTableRow: any = []
    tableHeadFilter = {
        status: '',
        cooperationName: '',
        customerConversionName: '',
        createdUserIdList: [],
        directorUserIdList: [],
        isBackMoney: '',
    }

    page = 1
    limit = 20
    total = 0
    loading = false
    menuBtn = menuBtn
    tableKey = Math.random()
    timer = null
    vdaH = 0 //屏幕高度

    popHeight = 0
    draggableList = []
    draggableListChange = []
    dialogShow = false
    formRules = {}
    formData = {
        cooperationName: '',
        cooperaitonPrice: '',
        ratio: '',
        price: '',
        directorUserRealName: '',
        contractUrl: '',
        customerConversionName : '',
        createdUserRealName:'',
        directorUserId:'',
        backMoneyUrl:'',
    }
    resaleId = null
    fileList = []
    fileId = ''
    contractLoading = false
    previewVisible = false
    previewPath = ''
    editDialogShow = false
    backMoneyUrl = ''
    fileList1 = []
    contractLoading1 = false
    previewVisible1 = false
    previewPath1 = ''



    // computed


    get userId() {
        return UserModule.userId
    }


    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    // created
    created() {
        this.getTableHeader()

        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260;
        this.popHeight = this.vdaH
    }

    // methods
    beforeUpload() {
        this.contractLoading = true;//上传时显示
        // this.$message("正在上传中，请稍后")
    }

    handleChange(file, fileList) {
        if (fileList.length > 1) {
            this.fileList = [file]; // 限制只保留最新添加的文件
        }
    }

    handleChangeBackMoney(file, fileList) {
        if (fileList.length > 1) {
            this.fileList1 = [file]; // 限制只保留最新添加的文件
        }
    }

    uploadSuccess(res) {
        const {data} = res
        this.formData.contractUrl = data.ossUrl

        this.$message.success('上传成功')
        this.contractLoading = false
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }

        this.previewVisible = true
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }


    beforeUpload1() {
        this.contractLoading1 = true;//上传时显示
        // this.$message("正在上传中，请稍后")
    }

    uploadSuccess1(res) {
        const {data} = res
        this.backMoneyUrl = data.ossUrl
        this.$message.success('上传成功')
        this.contractLoading1 = false
    }

    uploadError1() {
        this.$message.error('上传失败')
    }

    handlePreview1(file) {
        if (file.response) {
            this.previewPath1 = file.response.data.url
        } else {
            this.previewPath1 = file.url
        }
        this.previewVisible1 = true
    }

    handleUploadRemove1(file) {
        this.fileList1 = this.fileList.filter(item => item.uid !== file.uid)
    }



    dialogCancle() {
        this.dialogShow = false
    }

    // 下载回款凭证
    async uploadBackMoney(row: any) {
        const obj = {id: row.id}
        const data: any = await getCustomerConversionResaleOrderBackMoneyUrlById(obj)

        if (data.backMoneyUrl) {
            this.$message.success('回款凭证下载成功')
            // const a: any = document.createElement('a')
            // a.href = data.backMoneyUrl //  URL对象
            // a.click() // 模拟点击
            window.open(data.backMoneyUrl, '_blank')
        } else {
            this.$message.error('该订单暂未上传回款凭证')
        }
    }

    async dialogConfirm() {
        await setCustomerConversionResaleOrderBackMoneyUrlById({
            id: this.resaleId,
            backMoneyUrl: this.backMoneyUrl
        })
        this.getTableData()
        this.$message.success('回款成功')
        this.fileList1 = []
        this.dialogShow = false
    }


    changeRatio(val){
        this.formData.price = String(Number(this.formData.cooperaitonPrice) * Number(val) / 100)
    }


    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(20)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }

    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }

    async getTableData() {
        this.loading = true
        const obj = this.removePropertyOfNull({
            ...this.tableHeadFilter,
            page: this.page,
            limit: this.limit
        })
        const data: any = await getCustomerConversionResaleOrderList(obj)

        this.tableData = data.customerConversionResaleOrderList
        this.total = data.allNum
        this.tableKey = Math.random()

        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false

    }


    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 17})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false

    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }



    // 编辑
    async editResaleOrder(row: any){
        this.resaleId = row.id

        const data: any = await getCustomerConversionResaleOrderById({id: row.id})
        this.editDialogShow = true
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.formData = JSON.parse(JSON.stringify(data.customerConversionResaleOrder))
        }, 100)

        this.fileList = [{name: '合同', url: this.formData.contractUrl}]



    }

    doResaleOrderCancel() {
        this.editDialogShow = false
        this.formData.cooperationName = ''
        this.formData.cooperaitonPrice = ''
        this.formData.ratio = ''
        this.formData.price = ''
        this.formData.directorUserRealName = ''
        this.formData.contractUrl = ''
        this.formData.customerConversionName = ''
        this.formData.createdUserRealName = ''
    }

    doResaleOrderConfirm(){
        if (this.formData.backMoneyUrl === null) {
            this.formData.backMoneyUrl = ''
        }
        if(!this.formData.contractUrl||!this.formData.ratio||!this.formData.cooperaitonPrice||!this.formData.directorUserId){
            this.$message.error('请将信息填写完整')
            return ;
        }

        const obj = {
            id: this.resaleId,
            cooperationName: this.formData.cooperationName,
            cooperaitonPrice: this.formData.cooperaitonPrice,
            ratio: this.formData.ratio,
            price: this.formData.price,
            directorUserId: this.formData.directorUserId,
            contractUrl: this.formData.contractUrl,
            backMoneyUrl: this.formData.backMoneyUrl,
        }
        //     编辑接口
        setCustomerConversionResaleOrderById(obj).then(() => {
            this.$message.success('编辑成功')
            this.editDialogShow = false
            this.getTableData()

        }).catch(() => {

            this.editDialogShow = false
        })
    }


    // 回款
    setBackMoney(row: any) {
        this.resaleId = row.id
        this.dialogShow = true
    }

    async clickFollow(row: any) {
        const obj = {id: row.id}
        const data: any = await getCustomerConversionResaleOrderContractUrlById(obj)
        this.$message.success('下载成功')
        // const a: any = document.createElement('a')
        // a.href = data.contractUrl //  URL对象
        // a.click() // 模拟点击
        window.open(data.contractUrl, '_blank')
    }

    changecreatedUserIdList(e) {
        this.tableHeadFilter.createdUserIdList = e.id
        this.pageChange(1)
    }

    changedirectorUserIdList(e) {
        this.tableHeadFilter.directorUserIdList = e.id
        this.pageChange(1)
    }

    changedirectorUserRealName(e) {
        this.formData.directorUserId = e.id
    }

//     转销开票
    setInvoice(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/resaleInvoiceRecord' + '?id=' +
            row.id + '&customerConversionName=' + row.customerConversionName + '&cooperationName=' + row.cooperationName, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

}
